jQuery(document).ready(function($) {
    var $scrollListener = {
        $scrollElement: $(window),
        covid: {
            el: $('#covid-banner')
        },
        bono_valenciano: {
            el: $('#bv-banner')
        },
        nbHDT: {
            el: $('.header-wrapper .navbar.hdt')
        },
        nbHDM: {
            el: $('.header-wrapper .navbar.hdm')
        },
        headerInner: {
            el: $('header.header-inner')
        },
        fadeElements: {
            els: $('.fade-on-scroll')
        },
        elScrollTop: function ($element) {
            return parseInt($element.offset().top);
        },
        $body: $(document.body),
        fadeOnScroll: function () {
            this.fadeElements.els.each(function () {
                var $element = $(this);

                if ($scrollListener.elScrollTop($element) + 30 < $scrollListener.getScrollTop() + $scrollListener.$scrollElement.height()) {
                    $element.addClass('visible');
                } else {
                    $element.removeClass('visible');
                }
            });
        },
        getScrollTop: function () {
            return parseInt(this.$scrollElement.scrollTop());
        },
        topNB: function () {
            if (this.getScrollTop() > 120) {
                if (this.headerInner.el.length === 0) {
                    this.nbHDT.el.addClass('fixed-top-h50');
                    this.nbHDM.el.addClass('fixed-top-h50');
                }
                //this.covid.el.addClass('d-none');
                this.bono_valenciano.el.addClass('d-none');
            } else {
                if (this.headerInner.el.length === 0) {
                    this.nbHDT.el.removeClass('fixed-top-h50');
                    this.nbHDM.el.removeClass('fixed-top-h50');
                }
                //this.covid.el.removeClass('d-none');
                this.bono_valenciano.el.removeClass('d-none');
            }
        }
    };

    $(window).scroll(function () {
        $scrollListener.topNB();
        $scrollListener.fadeOnScroll();
    });
    $scrollListener.topNB();
    $scrollListener.fadeOnScroll();

    var $gallery = $("#gallery-view");
    if ($gallery) {
        $gallery.lightGallery();
    }

    var $offer = $("#offer-details");
    if ($offer) {
        $offer.lightGallery();
    }

    $('#cookie-banner').cookieBar({ domain: 'dunahotel.es', name: 'agree_terms', closeButton : '.btn-dark', secure: true });

    var $oc = $('.open-calendar');
    if ($oc) {
        $oc.click(function (ev) {
            ev.preventDefault();
            $(this).parents(".input-group").children('input').focus();
        });
    }

});